import { render, staticRenderFns } from "./ForecastingCreate.vue?vue&type=template&id=fb6909f8&scoped=true"
import script from "./ForecastingCreate.vue?vue&type=script&lang=js"
export * from "./ForecastingCreate.vue?vue&type=script&lang=js"
import style0 from "./ForecastingCreate.vue?vue&type=style&index=0&id=fb6909f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6909f8",
  null
  
)

export default component.exports